import {Grid} from '@material-ui/core';
import {autobind} from 'core-decorators';
import AddressGrid from 'components/address-grid';
import Banners from 'components/banners';
import Button from 'components/button';
import EmptyMessage from 'components/empty-message';
import {Field, Form, Textarea} from 'components/forms';
import OrderSuccess from 'components/order-success';
import ProductTable from 'components/product-table';
import Spinner from 'components/spinner';
import { reverse } from 'core/urls';
import updateCartMutation from 'graphql/mutations/carts/update-cart.gql';
import createMerchandisingOrderMutation from 'graphql/mutations/orders/create-merchandising-order.gql';
import addressesQuery from 'graphql/queries/addresses.gql';
import cartQuery from 'graphql/queries/cart.gql';
import creditsQuery from 'graphql/queries/credits.gql';
import ordersQuery from 'graphql/queries/orders.gql';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { compose, graphql } from 'react-apollo';
import styles from './styles.css';

@compose(
    graphql(cartQuery, {name: 'cartData'}),
    graphql(addressesQuery, {
        name: 'addressesData',
        options: {
            fetchPolicy: 'network-only',
        },
    }),
    graphql(updateCartMutation, {
        props: ({mutate}) => ({
            onUpdate: variables => mutate({
                variables,
                refetchQueries: [{query: cartQuery}],
            }),
        }),
    }),
    graphql(createMerchandisingOrderMutation, {
        props: ({mutate}) => ({
            onSubmit: variables => mutate({
                variables,
                refetchQueries: [
                    {query: cartQuery},
                    {query: ordersQuery},
                    {query: creditsQuery},
                ],
            }),
        }),
    }),
)
@autobind
export default class Cart extends Component {
    static contextTypes = {
        router: PropTypes.object,
    };

    state = {
        orderId: '',
        updating: false,
        showCheckout: Boolean(this.getNewAddressId()),
    };

    getNewAddressId() {
        return this.props.location.state
            && this.props.location.state.returnData
            && this.props.location.state.returnData.address;
    }

    handleCheckoutStart() {
        this.setState({showCheckout: true});
    }

    async handleUpdate(variables) {
        this.setState({updating: true});
        await this.props.onUpdate(variables);
        this.setState({updating: false});
    }

    async handleSubmit(values) {
        this.setState({loading: true, errors: undefined});
        const variables = {address: values.address, extraData: JSON.stringify({notes: values.notes})};
        const response = await this.props.onSubmit(variables);
        if (response.data.createOrder.errors) {
            this.setState({loading: false, errors: response.data.createOrder.errors});
        } else {
            this.setState({orderId: response.data.createOrder.order.id});
        }
    }

    renderEmpty() {
        return (
            <div className={styles.empty}>
                <EmptyMessage message='Tu carrito está vacío.' />
            </div>
        );
    }

    renderSuccess() {
        return (
            <div className={styles.success}>
                <OrderSuccess
                    title='¡Pedido realizado exitosamente!'
                    orderId={this.state.orderId}
                />
            </div>
        );
    }

    renderCart() {
        const getDefaultAddress = () => {
            const newAddressId = this.getNewAddressId();
            if (newAddressId) return parseInt(newAddressId);
            
            const address = this.props.addressesData.addresses && this.props.addressesData.addresses.find(address => address.isDefault);
            return address ? address.id : undefined;
        };

        return (
            <Form
                fields={[
                    {
                        key: 'address',
                        initial: getDefaultAddress(),
                    },
                    {key: 'notes', initial: '', required: false},
                ]}
                errors={this.state.errors}
                onSubmit={this.handleSubmit}>
                {({getFieldProps, renderErrors, isValid}) => (
                    <div className={styles.cart}>
                        <ProductTable
                            columns={['product', 'code', 'price', 'quantity', 'total']}
                            items={this.props.cartData.cart.items}
                            total={this.props.cartData.cart.total}
                            totalCurrency={this.props.cartData.cart.totalCurrency}
                            onUpdate={this.handleUpdate}
                            disabled={this.state.updating}
                        />
                        <div className={styles.checkout}>
                            <Field label='Comentarios para Nidera'>
                                <Textarea {...getFieldProps('notes')} />
                                {renderErrors('notes')}
                            </Field>
                            <p className={styles.title}>Elegí una dirección de envío:</p>
                            {this.props.addressesData.loading
                                ? <Spinner />
                                : (
                                    <Fragment>
                                        <AddressGrid
                                            addresses={this.props.addressesData.addresses}
                                            returnUrl={reverse('cart')}
                                            {...getFieldProps('address')}
                                        />
                                        {renderErrors('address')}
                                    </Fragment>
                                )
                            }
                            <Grid container>
                                <Grid item xs={6}>
                                    <Button theme='black' onClick={()=>this.props.history.goBack()}>
                                                Volver
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Form.Actions align='right'>
                                        <Grid container spacing={2} justify='flex-end'>
                                            <Grid item sx={12}>
                                                <Button type='submit' theme='yellow' disabled={!isValid() || this.state.loading}>
                                                    {this.state.loading ? 'Cargando...' : 'Enviar'}
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className={styles.errors}>
                                                    {renderErrors('__all__')}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Form.Actions>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                )}
            </Form>
        );
    }

    render() {
        if (this.props.cartData.loading) return <Spinner />;

        const itemCount = this.props.cartData.cart.items.length;
        return (
            <div className={styles.root}>
                {!this.state.orderId && itemCount === 0 && this.renderEmpty()}
                {!this.state.orderId && itemCount > 0 && this.renderCart()}
                {this.state.orderId && this.renderSuccess()}
                <Banners noCredit />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/cart/index.js